import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon } from '..';

import style from './SomethingGoingWrong.module.scss';


export const SomethingGoingWrong = ({ reload, reloadMessage, withBack, children, errorDetails = null }) => {
  const [ t ] = useTranslation();
  const [ childrenVisibility, setChildrenVisibility ] = useState(false);

  return (
    <>
      {!childrenVisibility && (
        <div className={ style.row }>
          <span className={ style.msg }>
            {t('ERR.sthWentWrong')}
            <Icon
              svg="ERROR"
              svgProps={{ width: '20', height: '20' }}
              vendorClass={ style.icon }
            />
          </span>
          {errorDetails}
        </div>
      ) }
      { reload && (
        <Button onClick={ reload }>
          {reloadMessage || t('noData.reloadPage')}
        </Button>
      )}
      { (withBack && !childrenVisibility) && (
        <div className={ style.wrapper }>

          <Button
            additions={ [ 'fit-content', 'primary-icon' ] }
            onClick={ () => {
             setChildrenVisibility(true);
            } }
          >
            <Icon
              svg="RECAL"
              svgProps={{ width: '28', height: '28' }}
            />
            <p>
              {t('btns.back')}
            </p>
          </Button>
        </div>

      )}
      {childrenVisibility && children}
    </>
  );
};

